
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/zarezerwuj-podroze",
      function () {
        return require("private-next-pages/[region]/[resort]/zarezerwuj-podroze.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/zarezerwuj-podroze"])
      });
    }
  